export const CHALLENGE = {
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  MFA_SETUP: 'MFA_SETUP',
  SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
  PASSWORD_VERIFIER: 'PASSWORD_VERIFIER',
} as const;
export type LoginChallenge = (typeof CHALLENGE)[keyof typeof CHALLENGE];
